<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="800">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Crear dosificacion</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-row>
              <v-col cols="12" sm="4">
                <!-- <v-text-field v-model="dosis.nit" dense outlined label="Nit"></v-text-field> -->
                <v-select
                  :items="nits"
                  v-model="dosis.nit"
                  label="Nit:"
                  item-text="nro"
                  item-value="nro"
                  hide-details
                  dense
                  outlined
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.number="dosis.numero_inicial_factura"
                  dense
                  outlined
                  type="number"
                  label="Numero inicial factura"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="dosis.numero_autorizacion"
                  dense
                  outlined
                  label="Numero autorizacion"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="dosis.llave_dosificacion"
                  dense
                  outlined
                  label="Llave dosificacion"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  :items="actividades"
                  v-model="dosis.actividad"
                  label="Actividad:"
                  item-text="descripcion"
                  item-value="descripcion"
                  hide-details
                  dense
                  outlined
                />
                <!-- <v-text-field v-model="dosis.actividad" dense outlined label="Actividad"></v-text-field> -->
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field v-model="dosis.linea1" dense outlined label="Linea 1"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="dosis.linea2" dense outlined label="Linea 2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="dosis.fecha_limite"
                  type="date"
                  dense
                  outlined
                  label="Fecha limite"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="registrar()" class="green" dark> {{ dosis.id ? 'Actualizar' : 'Registrar' }} </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import axios from 'axios';
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  import { getAccessToken } from '@/accessToken';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        nits: [],
        actividades: [],
        apikeytoken: '',
        dosis: {
          id: null,
          nit: '4265269017',
          numero_inicial_factura: 1,
          numero_autorizacion: '434401100070307',
          llave_dosificacion: 'HE4V8c=HYaiq6{\\$=D]$feLR@@\\=ZWSCvn4=zXC*4Ac8YLFvVX)T=G24]DN-hFTQ',
          actividad: 'ENSEÑANZA SUPERIOR',
          linea1: 'PROHIBIDA SU EMISIÓN PARA ESPECTÁCULO PÚBLICO EVENTUAL',
          linea2: 'Ley N° 453: Los servicios deben suministrarse en condiciones de inocuidad, calidad y seguridad.',
          fecha_limite: '2022-05-05',
          sucursal_id: 1,
        },
      };
    },
    components: {},
    methods: {
      async openmodal(item) {
        let idsucursal = this.$route.query.idsucursal;
        //window.console.log(item);
        this.msg = '';
        this.dialog = true;
        await this.obtenerToknFactura(idsucursal);
        this.loading = false;
        this.dosis.id = null;
        this.dosis.nit = null;
        this.dosis.numero_inicial_factura = null;
        this.dosis.numero_autorizacion = null;
        this.dosis.llave_dosificacion = null;
        this.dosis.actividad = null;
        this.dosis.linea1 = null;
        this.dosis.linea2 = null;
        this.dosis.fecha_limite = null;
        this.dosis.sucursal_id = parseInt(idsucursal);
        this.nits = await this.getNits();
        this.actividades = await this.getactividades();
        if (item) {
          this.dosis.id = item.id;
          this.dosis.nit = item.nit;
          this.dosis.numero_inicial_factura = item.numero_inicial_factura;
          this.dosis.numero_autorizacion = item.numero_autorizacion;
          this.dosis.llave_dosificacion = item.llave_dosificacion;
          this.dosis.actividad = item.actividad;
          this.dosis.linea1 = item.linea1;
          this.dosis.linea2 = item.linea2;
          this.dosis.fecha_limite = item.fecha_limite;
          this.dosis.sucursal_id = item.sucursal_id;
        }
      },
      async obtenerToknFactura(idsuc) {
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
      getactividades() {
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/actividad`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
          },
        };
        return xaxios.request(config).then(({ data }) => (data ? data : []));
      },
      getNits() {
        const qs = gql`query{ ${''} getNits{ id, nombre, descripcion, nro, estado }}`;
        return this.$apollo.query({ query: qs }).then(({ data }) => (data.getNits ? data.getNits : []));
      },

      registrar() {
        this.msg = '';
        if (!this.dosis.numero_inicial_factura) this.msg = 'Ingrese numero inicial factura';
        if (!this.dosis.llave_dosificacion) this.msg = 'Ingrese llave dosificacion';
        if (!this.dosis.numero_autorizacion) this.msg = 'Ingrese numero autorizacion';
        if (!this.dosis.nit) this.msg = 'Ingrese nit';
        if (!this.dosis.actividad) this.msg = 'Ingrese actividad';
        if (!this.dosis.sucursal_id) this.msg = 'Ingrese sucursal id';
        if (!this.dosis.linea1) this.msg = 'Ingrese linea1';
        if (!this.dosis.linea2) this.msg = 'Ingrese linea2';
        if (!this.dosis.fecha_limite) this.msg = 'Ingrese fecha limite';
        if (this.msg) return;

        let vue = this;
        vue.loading = true;
        let metodo = 'post';
        if (this.dosis.id) metodo = 'put';
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/dosificaciones`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: this.dosis,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('registrar:', data);
            vue.$emit('newregdosis', data);
            vue.dialog = false;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
          });
      },
    },
  };
</script>
